import { en, ge } from "vuejs-datepicker/dist/locale";

const locales = {
  en,
  ka: ge,
};

export function getDatepickerLocale(locale) {
  return locales[locale];
}
